import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import EthicsCategoryPage from '@/pages/category/ethics/page';
import LatestCategoryPage from '@/pages/category/latest/page';
import ClassicCategoryPage from '@/pages/category/classic/page';
import DetailPage from '@/pages/detail/page';
import SearchPage from '@/pages/search/page';
import AboutPage from '@/pages/about/page';
import ContactPage from '@/pages/contact/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/category/ethics', element: <EthicsCategoryPage /> },
  { path: '/category/latest', element: <LatestCategoryPage /> },
  { path: '/category/classic', element: <ClassicCategoryPage /> },
  { path: '/detail/:id', element: <DetailPage /> },
  { path: '/search', element: <SearchPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;